import { Auth } from 'aws-amplify';
import appConfig from '../config/app-config';

const API = appConfig.apis.contractsManagementApiEnv;

const getHeaders = async (): Promise<Record<string, string>> => {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    return {
        'Content-Type': 'application/json',
        'x-api-key': API.key,
        'Authorization': `Bearer ${token}`,
    };
};

export interface OperationResult {
    credit_operation_id: string;
    sequencial_number: number;
    operation_number: string;
    operation_type: string;
    credit_product_type_name?: string;
    status: string;
    approved_value: number;
    nominal_value: number | null;
    loan_amount: number | null;
    participants: any[];
    operation_dictionary?: any;
}

export const contractsManagementApi = {
    /** Busca operações (todas) por termo de pesquisa */
    searchOperations: async (search: string): Promise<OperationResult[]> => {
        if (!search || search.length < 2) return [];
        const res = await fetch(
            `${API.address}/contracts/page-list?search=${encodeURIComponent(search)}&page=0&pageSize=10`,
            { headers: await getHeaders() }
        );
        if (!res.ok) return [];
        const data = await res.json();
        return data.list || data.data || [];
    },

    /** Busca operações de cessão de recebíveis por termo de pesquisa */
    searchReceivableAssignments: async (search: string): Promise<OperationResult[]> => {
        if (!search || search.length < 2) return [];
        const res = await fetch(
            `${API.address}/contracts/receivables_assignment/list?search=${encodeURIComponent(search)}&page=0&pageSize=10`,
            { headers: await getHeaders() }
        );
        if (!res.ok) return [];
        const data = await res.json();
        return data.list || [];
    },

    /** Busca uma operação de cessão de recebíveis pelo ID */
    getReceivableAssignmentById: async (operationId: string): Promise<OperationResult | null> => {
        const res = await fetch(
            `${API.address}/contracts/receivables_assignment/${operationId}`,
            { headers: await getHeaders() }
        );
        if (res.status === 404) return null;
        if (!res.ok) throw new Error(`Erro ao buscar operação: ${res.status}`);
        const json = await res.json();
        const data = json.data || json;
        if (!data.credit_operation_id) throw new Error('Resposta inesperada da API de operações');
        return data;
    },
};
